enum LeaderboardDuration {
    Monthly = 'monthly',
    Yearly = 'yearly',
    AllTime = 'all-time'
}

enum LeaderboardDurationLabel {
    Monthly = 'This Month',
    Yearly = 'This Year',
    AllTime = 'Lifetime'
}

export { LeaderboardDuration, LeaderboardDurationLabel };
